// src/services/asset.service.js
import { api } from './api';

class AssetService {
    // ─── Categories ──────────────────────────────────────────────────
    async getCategories() {
        const response = await api.get('/api/assets/categories');
        return response.data;
    }

    async createCategory(data) {
        const response = await api.post('/api/assets/categories', data);
        return response.data;
    }

    async updateCategory(id, data) {
        const response = await api.put(`/api/assets/categories/${id}`, data);
        return response.data;
    }

    async deleteCategory(id) {
        const response = await api.delete(`/api/assets/categories/${id}`);
        return response.data;
    }

    // ─── Assets ──────────────────────────────────────────────────────
    async getAssets(params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/api/assets?${query}`);
        return response.data;
    }

    async getAsset(id) {
        const response = await api.get(`/api/assets/${id}`);
        return response.data;
    }

    async createAsset(data) {
        const response = await api.post('/api/assets', data);
        return response.data;
    }

    async updateAsset(id, data) {
        const response = await api.put(`/api/assets/${id}`, data);
        return response.data;
    }

    async deleteAsset(id) {
        const response = await api.delete(`/api/assets/${id}`);
        return response.data;
    }

    // ─── Assign / Return ─────────────────────────────────────────────
    async assignAsset(id, employeeId) {
        const response = await api.post(`/api/assets/${id}/assign`, { employeeId });
        return response.data;
    }

    async returnAsset(id, data = {}) {
        const response = await api.post(`/api/assets/${id}/return`, data);
        return response.data;
    }

    // ─── Maintenance ─────────────────────────────────────────────────
    async getAllMaintenance(params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/api/assets/maintenance/all?${query}`);
        return response.data;
    }

    async createMaintenance(id, data) {
        const response = await api.post(`/api/assets/${id}/maintenance`, data);
        return response.data;
    }

    async updateMaintenance(assetId, maintenanceId, data) {
        const response = await api.put(`/api/assets/${assetId}/maintenance/${maintenanceId}`, data);
        return response.data;
    }

    // ─── Audit Log ───────────────────────────────────────────────────
    async getAllAuditLog(params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/api/assets/audit-log/all?${query}`);
        return response.data;
    }

    async getAuditLog(id, params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/api/assets/${id}/audit-log?${query}`);
        return response.data;
    }

    // ─── Stats ───────────────────────────────────────────────────────
    async getStats() {
        const response = await api.get('/api/assets/dashboard/stats');
        return response.data;
    }
}

const assetService = new AssetService();
export default assetService;
